import React, { useEffect } from 'react'
import { Container } from 'reactstrap'

import jobFulfillmentVenn300 from './JobFulfillmentVenn300-2300x1709-transparent.png'

export const Fulfillment = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <Container>
            <h2>The Job Fulfillment Factor</h2>
            <p>
                Now that you know the values that define the "true you", and your Job Passion Types&trade;,
                you have important clues that can help you find job fulfillment.
            </p>
            <p>
                The importance of job fulfillment extends far beyond personal satisfaction. Extensive
                research underscores the significance of job fulfillment as a key factor in driving
                employee motivation and engagement.
            </p>
            <p>
                When employees find their work genuinely fulfilling, they show increased commitment
                and loyalty to their organization, which, in turn, increases their productivity. This
                increased productivity not only enhances the performance of employees but also translates
                into tangible benefits for the organization, including lower turnover rates, reduced
                absenteeism, and higher profitability.
            </p>
            <p>
                Fulfilled employees are more likely to engage in creative problem-solving, contribute to
                a positive work environment, and advocate for their company, which can enhance the
                organization's reputation and attract top talent. Prioritizing job fulfillment can also
                lead to better customer satisfaction and loyalty as engaged employees are more likely to
                deliver superior customer service.
            </p>
            <p>
                Therefore, fostering an environment that promotes job fulfillment is not merely aspirational;
                it is a strategic necessity that can drive organizational success. By pursuing job fulfillment,
                employees and employers alike can forge a more dynamic, productive, and sustainable future.
            </p>
            <p>
                You will feel job fulfillment whenever your work provides you with enjoyment, meaning, and
                engagement. This will happen whenever your skills, passions, and purpose overlap.
            </p>

            <img className="img-fluid mx-auto my-auto d-block w-75" style={{ paddingBottom: "20px" }} src={jobFulfillmentVenn300} alt="Job fulfillment" />

            <p>
                <strong style={{fontWeight: 800}}>Enjoyment:</strong> Many people move up in their careers by using the skills they
                learn and get good at. Although this guarantees that they will do a good job, it doesn't
                necessarily mean that they will enjoy their work. Now that you know your Job Passion Types&trade;,
                you'll easily be able to identify which of your current skills give you enjoyment and which
                ones don't. The more skills that align with your Job Passion Types&trade; the more enjoyment you'll
                feel from the work you do. 
            </p>
            <p>
                <strong style={{fontWeight: 800}}>Meaning:</strong> If you want your job to have meaning, you need to have a sense of
                purpose when you use your skills. People often feel like they have a purpose in life because
                they believe in the values and beliefs that guide the company they work for. Now that you know
                what your values are, you can figure out how well they match up with the values of your employer
                and how that can provide meaning for you.
            </p>
            <p>
                <strong style={{fontWeight: 800}}>Engagement:</strong> When you use skills that are in line with both your passions and
                your purpose, you'll be so excited and involved in your work that you might forget how much time
                has passed. It's how an athlete feels when they're "in the zone." This is the point at which you
                will finally feel fulfillment from your work. 
            </p>
        </Container>
    )
}
